import { TogglesController } from "../controller";

export default class extends TogglesController {
  _activate() {
    this._activateButton();
    this._showActiveIcon();
    this._hideInactiveIcon();
  }

  _deactivate() {
    this._deactivateButton();
    this._hideActiveIcon();
    this._showInactiveIcon();
  }

  _activateButton() {
    this.element.classList.remove("bg-gray-200");
    this.element.classList.add("bg-indicator-purple-primary");
  }

  _deactivateButton() {
    this.element.classList.remove("bg-indicator-purple-primary");
    this.element.classList.add("bg-gray-200");
  }

  _showActiveIcon() {
    this.activeIconTarget.classList.remove(
      "opacity-0",
      "duration-75",
      "ease-out"
    );
    this.activeIconTarget.classList.add(
      "opacity-100",
      "duration-75",
      "ease-in"
    );
  }

  _hideActiveIcon() {
    this.activeIconTarget.classList.remove(
      "opacity-100",
      "duration-75",
      "ease-in"
    );
    this.activeIconTarget.classList.add(
      "opacity-0",
      "duration-75",
      "ease-out"
    );
  }

  _showInactiveIcon() {
    this.inactiveIconTarget.classList.remove(
      "opacity-0",
      "duration-75",
      "ease-out"
    );
    this.inactiveIconTarget.classList.add(
      "opacity-100",
      "duration-75",
      "ease-in"
    );
  }

  _hideInactiveIcon() {
    this.inactiveIconTarget.classList.remove(
      "opacity-100",
      "duration-75",
      "ease-in"
    );
    this.inactiveIconTarget.classList.add(
      "opacity-0",
      "duration-75",
      "ease-out"
    );
  }
}
